export default "__VITE_ASSET__BLN4tQ3b__"